import * as React from 'react';

function SvgTickFailureRed(props) {
  return (
    <svg width={64} height={64} xmlns="http://www.w3.org/2000/svg" {...props}>
      <g fill="none" fillRule="evenodd">
        <circle fill="#FFEDE4" cx={32} cy={32} r={32} />
        <path
          d="M31 42h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2c0-1.1.9-2 2-2zm0-26h2a2 2 0 012 2v20a2 2 0 01-2 2h-2a2 2 0 01-2-2V18c0-1.1.9-2 2-2z"
          fill="#FD8649"
        />
      </g>
    </svg>
  );
}

export default SvgTickFailureRed;
